import { render, staticRenderFns } from "./DistributedTracingRED.vue?vue&type=template&id=06706e0a&scoped=true"
import script from "./DistributedTracingRED.vue?vue&type=script&lang=js"
export * from "./DistributedTracingRED.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06706e0a",
  null
  
)

export default component.exports